import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Location } from 'apis/MapboxAPI';

const currentYear = new Date().getFullYear();

export interface CompanyMetadataFormData {
  location?: Location;
  founded: string;
}

export interface UseCompanyMetadataFormOptions {
  onSubmit: (data: { location: Location; founded: string }) => void;
  initialValues?: Partial<CompanyMetadataFormData>;
}

export function useCompanyMetadataForm({ onSubmit, initialValues }: UseCompanyMetadataFormOptions) {
  return useFormik<CompanyMetadataFormData>({
    initialValues: {
      founded: '',
      location: undefined,
      ...initialValues,
    },
    validationSchema: Yup.object().shape({
      founded: Yup.number()
        .typeError('Please enter a valid year (e.g., 2010)')
        .required('Founding year is required')
        .min(1980, 'Year must be 1980 or later')
        .max(currentYear, `Year cannot be later than ${currentYear}`),

      location: Yup.object().required('Company location is required'),
    }),
    onSubmit: values => {
      if (values.location) {
        onSubmit({
          location: values.location,
          founded: String(values.founded), // Ensure it's always a string
        });
      }
    },
  });
}
